import type { SVGProps } from "react";
export function Edit(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m13.1583 2.84171c-.4556-.45561-1.1944-.45561-1.65 0l-.6464.64644 1.6499 1.64992.6465-.64644c.4556-.45562.4556-1.19431 0-1.64992zm-1.3536 3.00347-1.6499-1.64992-7.6548 7.65484v1.6736h1.62623zm-1.0035-3.71058c.8462-.84613 2.218-.84613 3.0641 0 .8462.84614.8462 2.21799 0 3.06413l-9.17841 9.17847c-.09377.0938-.22095.1465-.35356.1465h-2.33333c-.27614 0-.5-.2239-.5-.5v-2.3808c0-.1326.05268-.2598.14645-.3535z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
